<template>
  <div style="width:100%; height: 100%;">
    <el-table
      row-key="id"
      class="scpc-task-table"
      :data="table_config.tableData"
      :header-cell-style="{
        background: '#F1F1F1 ',
        fontSize: '14px',
        color: '#999999'
      }"
      :cell-style="{
        fontSize: '14px',
      }"
      :row-style="{ height: '38' }"
      :style="{
        width: type === 'examine' ? 'calc(100% - 35px)' : 'calc(100% - 235px)',
        height: tableHeight
      }"
      @cell-click="cellClick"
      v-el-table-infinite-scroll="config.loadList"
    >
      <template>
        <template v-for="item in table_config.thead" class="scpc-task">
          <!-- 绩效周期 -->
          <el-table-column
            v-if="item.prop === 'meritsDate'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
            width="120"
          >
            <template slot-scope="scope">
              <span class="scope-content-id">{{scope.row.meritsDate}}</span>
            </template>
          </el-table-column>
          <!-- 待评人员 -->
          <el-table-column
            v-if="item.prop === 'meritsUserModel'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.meritsUserModel.name" />
                </span>
                <span v-else>{{scope.row.meritsUserModel.name}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 评分阶段 -->
          <el-table-column
            v-else-if="item.prop === 'currentFlowName'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
            min-width="130"
          >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;" :style="`color: ${scope.row.currentFlowColor}`">
                <span class="">{{scope.row.currentFlowName}}</span>
                <div v-if="scope.row.currentUserList && scope.row.currentUserList.length > 0" v-show="type === 'examine'">
                  <div v-for="(item1, index) in scope.row.currentUserList" :key="index">
                    (
                    <span v-if="channel === 'wechat'">
                      <ww-open-data type="userName" :openid="item1.name" />
                    </span>
                    <span v-else>{{item1.name}}</span>
                    <span v-show="scope.row.currentUserList.length-1!=index">,</span>)
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 评分人 -->
          <el-table-column
            v-else-if="item.prop === 'currentUser'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.currentUserList && scope.row.currentUserList.length > 0">
                <div v-for="(item1, index) in scope.row.currentUserList" :key="index">
                  <span v-if="channel === 'wechat'">
                    <ww-open-data type="userName" :openid="item1.name" />
                  </span>
                  <span v-else>{{item1.name}}</span>
                  <span v-show="scope.row.currentUserList.length-1!=index">,</span>
                </div>
              </div>
              <div v-else class="table_none">-</div>
            </template>
          </el-table-column>
          <!-- 考评得分 -->
          <el-table-column
            v-else-if="item.prop === 'realityScore'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <div>{{scope.row.realityScore}}</div>
              <!-- <div v-else class="table_none">-</div> -->
            </template>
          </el-table-column>
          <!-- 考评等级 -->
          <el-table-column
            v-else-if="item.prop === 'gradeName'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
            min-width="120"
          >
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <span>
                  <span :style="scope.row.gradeColor ? `color: ${scope.row.gradeColor}` : 'color: #2878ff'" v-if="scope.row.gradeName">{{scope.row.gradeName}}</span>
                  <span v-else class="table_none">-</span>
                </span>
                <span style="padding-left: 5px;" v-if="scope.row.gradeRemark">({{scope.row.gradeRemark}})</span>
              </div>
            </template>
          </el-table-column>
          <!-- 提前完成 -->
          <el-table-column
            v-else-if="item.prop === 'aheadCount'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id" style="color: #2db039;padding-left: 21px;cursor: pointer;" @click="openDetail(scope.row, '1')">{{scope.row.aheadCount}}</span>
            </template>
          </el-table-column>
          <!-- 正常完成 -->
          <el-table-column
            v-else-if="item.prop === 'normalCount'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id" style="color: #2878ff;padding-left: 21px;cursor: pointer;" @click="openDetail(scope.row, '0')">{{scope.row.normalCount}}</span>
            </template>
          </el-table-column>
          <!-- 逾期完成 -->
          <el-table-column
            v-else-if="item.prop === 'extensCount'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <span class="scope-content-id" style="color: #dd483f;padding-left: 21px;cursor: pointer;" @click="openDetail(scope.row, '2')">{{scope.row.extensCount}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            v-else-if="item.prop === 'controls'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <!-- <el-button plain>明细</el-button> -->
              <el-button plain v-if="scope.row.status !== '1'&& scope.row.currentUserId == UserData.userId" type="primary">评分</el-button>
              <el-button plain v-else>查看</el-button>
              <!-- <span class="scope-content-id" style="color: $color_main;">明细</span> -->
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.prop === 'reviewe'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
          >
            <template slot-scope="scope">
              <!-- <el-button plain>明细</el-button> -->
              <el-button plain v-if="scope.row.status !== '1' && scope.row.currentUserId == UserData.userId" type="primary">评分</el-button>
              <el-button plain v-else>查看</el-button>
              <!-- <span class="scope-content-id" style="color: $color_main;">明细</span> -->
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.prop === 'todocontrol'"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="item.render_header"
            width="110"
          >
            <template slot-scope="scope">
              <div v-if="type=== 'examine'" style="display: flex;align-items: center;">
                <el-button plain v-if="scope.row.status !== '1' && scope.row.submitFlag" type="primary">评分</el-button>
                <el-button plain v-else>查看</el-button>
                <!-- <span style="color: $color_main;">评分</span> -->
                 <!-- v-if="scope.row.status !== '1'" -->
                <div style="border-left: 1px solid #909090; width: 2px; height: 15px;margin: 0 10px;" />
                <el-tooltip
                  effect="dark"
                  content="删除"
                  placement="top"
                  popper-class="texttooltip"
                >
                  <i class="iconfont icon-shanchu1 icon_btn" @click.stop="delFollow(scope.$index, scope.row)" style="cursor: pointer;" />
                </el-tooltip>
              </div>
              <div v-else>
                <el-button plain type="primary">评分</el-button>
                <!-- <span class="scope-content-id" style="color: $color_main;">评分</span> -->
              </div>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
import { merdelete } from '../../utils/api/kpiV2'
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    shou: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      UserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      check_list: [],
      // 表格配置
      table_config: {
        thead: [],
        tableData: []
      },
      clientHeights: document.documentElement.clientHeight
    }
  },
  computed: {
    // 动态计算表格高度
    tableHeight() {
      return this.type === 'examine' ? '91%' : '85%'
    }
  },
  // 监听config是否有东西进来
  watch: {
    shou: {
      handler() {
        this.table_config.tableData = this.config.tableData
      }
    },
    config: {
      handler(newValue) {},
      // 初始化监听
      immediate: true
    }
  },
  mounted() {
    this.table_config = this.config
    console.log(this.table_config, 'this.table_config')
  },
  methods: {
    // 单元格方法
    cellClick(row, column) {
      // if (column.property === 'normalCount' && column.label === '正常完成') {
      //   this.$emit('checkdetail', row, '0')
      // } else if (column.property === 'extensCount' && column.label === '逾期完成') {
      //   this.$emit('checkdetail', row, '2')
      // } else if (column.property === 'aheadCount' && column.label === '提前完成') {
      //   this.$emit('checkdetail', row, '1')
      // } else {
      //   this.$emit('checkdetail', row, '')
      // }
      this.$emit('checkdetail', row, '')
    },
    openDetail(row, type) {
      this.$emit('checkdetail', row, type)
    },
    // 数据加载
    loadList() {
      console.log(this.$parent, 'this.$parent')
      // this.$parent.loadList()
      // this.table_config.tableData = this.table_config.tableData.concat(this.table_config.tableData)
    },
    delFollow(index, row) {
      this.$confirm('此操作将删除该考核内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: row.id
        }
        merdelete(date)
          .then((data) => {
            if (data.code === 10000) {
              this.table_config.tableData.splice(index, 1)
            } else {
              this.$message.error(data.info)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
::v-deep .el-table {
  position: absolute;
}
::v-deep .el-table .cell {
  display: flex;
  align-items: center;
  height: 38px;
  line-height: 38px !important;
}
::v-deep .el-table__body-wrapper {
  height: calc(100% - 85px)!important;
  padding-bottom: 38px;
}
::v-deep .el-table .el-table__expand-icon {
  margin-left: -16px;
}
.scope-content-id {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
::v-deep .el-table [class*='el-table__row--level'] .el-table__expand-icon {
  margin-right: 0px;
}
::v-deep .tableTextColor div span{
  font-size: $font_12;
  border-radius: 4px;
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
}
::v-deep .tableTextColor8 div {
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
  color: #fa7068;
}
// 未指派
.tableTextColor1 div span{
  color: #f1ad38;
  background: rgba(241, 173, 56, 0.1);
}
// 未完成
.tableTextColor2 div span{
  color: #74bf7a;
  background: rgba(116, 191, 122, 0.1);
}
// 待测试
.tableTextColor3 div span{
  color: #ff9c95;
  background: rgba(255, 156, 149, 0.1);
}
// 测试中
.tableTextColor4 div span{
  color: #fa7068;
  background: rgba(250, 112, 104, 0.1);
}
// 待确认
.tableTextColor5 div span{
  color: #8fb9ff;
  background: rgba(143, 185, 255, 0.1);
}
// 已完成
.tableTextColor6 div span{
  color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
// 已终止
.tableTextColor7 div span{
  color: #a8a8a8;
  background: rgba(168, 168, 168, 0.1);
}
.scpc-task-table {
  .scpc-operate-photos {
    // width: 30px;

    min-width: 30px;
    max-width: 50px;
    // border-radius: 50%;
    overflow: hidden;
  }
  .scope-content {
    width: 100%;
    display: flex;
    align-items: center;
    .scope-content-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }
    .scpc-operate-icon {
      flex: none;
    }
    .scpc-operate-icon:hover.liuchen_icon {
      display: inline-block;
    }
    .scpc-operate-photo {
        .img {
        width: 27px;
        height: 27px;
        font-size: $font_14;
        font-family: $font_family1;
        font-weight: 400;
        color: $color_white;
        line-height: 27px;
        text-align: center;
        background: $color_main;
        border-radius: 50%;
        margin-right: 10px;
      }
      div {
        img {
          width: 27px;
          height: 27px;
          border-radius: 50%;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
  }
}
.task_within {
  font-weight: 400;
  font-size: $font_12;
  padding: 1px 1px 0 1px;
  line-height: 14px;
  border-radius: 3px;
  color: #dd483f;
  background: $color_white;
  border: 1px solid #dd483f;
  margin-right: 10px;
}
::v-deep .el-table thead .el-table__cell {
  padding: 0 !important;
}
::v-deep.el-table__row:not([class*='el-table__row--level-']) {
  td:nth-child(2) {
    padding-left: 24px !important;
  }
}
::v-deep .el-table__placeholder{
margin-left: -15px !important;
}
::v-deep .el-button {
  padding: 0 10px !important;
  font-size: 12px;
}
</style>
